import React from 'react';
import { NavbarPrimaryDesktopDropdownNavItem } from './NavbarPrimaryDesktopDropdownNavItem';
import { NavbarPrimarySingleNavItem } from './NavbarPrimarySingleNavItem';

const NavbarPrimaryDesktopItem = ({ nav, page, sanity }) => {
  const { type } = nav || {};

  return type === 'single' ? (
    <NavbarPrimarySingleNavItem nav={nav} page={page} sanity={sanity} />
  ) : (
    <NavbarPrimaryDesktopDropdownNavItem
      nav={nav}
      page={page}
      sanity={sanity}
    />
  );
};

export { NavbarPrimaryDesktopItem };
